import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loading(props) {
  let cls = props?.className ? props?.className : "";
  return <CircularProgress className={`${cls}`} />;
}
